import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http'; 

import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, withLatestFrom } from 'rxjs/operators';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ImportService } from '../../../shared/basic-data-management/import-service.class';

export interface ImportDialogData {
	service: ImportService;
}

@Component({
	templateUrl: 'import-dialog.html',
	styleUrls: ['import-dialog.css'],
})
export class ImportDialogComponent {
	file$ = new BehaviorSubject<File | null>(null);
	importButtonDisabled$!: Observable<boolean>; 
	importRequest$ = new Subject<void>(); 
	
	waitingForServer: boolean = false;
	errorMessage: string | null = null;
	
	constructor(
		dialogRef: MatDialogRef<ImportDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ImportDialogData,
	) {
		this.importButtonDisabled$ = this.file$.pipe(
			map(
				(file) => file === null
			)
		);
		
		this.importRequest$.pipe(
			withLatestFrom(this.file$)
		).subscribe(
			([_, file]) => {
				if (!file) {
					return;
				}
				
				this.waitingForServer = true;
				this.errorMessage = null;
				data.service.import(file).subscribe(
					(count) => {
						alert("Entrées créées: " + count);
						dialogRef.close(true);
					},
					(response: HttpErrorResponse) => {
						this.waitingForServer = false;
						let message = "Le serveur a rencontré une erreur imprévue";
						if (response.status === 0) {
							message = "Erreur du navigateur: Le fichier peut avoir été modifié depuis sa sélection, veuillez le resélectionner.";
						} else if (response.error && response.error.message) {
							message = response.error.message;
						}
						this.errorMessage = message;
						
						// Il faut remettre le champ de fichier a vide, car certains navigateurs
						// ne supportent pas de renvoyer la meme selection de ficheir deux fois
						this.fileInputRef.nativeElement.value = "";
						this.file$.next(null);
					}
				);
			}
		);
	}
	
	@ViewChild("fileInput") fileInputRef!: ElementRef; 
	
	onFileSelected(event: Event) {
		let inputElement = event.target as HTMLInputElement;
		let files: FileList | null = inputElement.files;
		if (files) {
			this.file$.next(files[0]);
		}
	}
}